import { price as priceUtils } from '@eti/utils';
import { change as changeFormValue } from 'redux-form';
import { getPriceDivided as getPricePerBound } from '../../../common/utils/price';
export const getSecondBagPrice = (shouldShowPricePerBoundSecondBag, numberOfBounds, currentSecondBagTraveler) => {
  return priceUtils.formatPrice(shouldShowPricePerBoundSecondBag ? getPricePerBound(currentSecondBagTraveler === null || currentSecondBagTraveler === void 0 ? void 0 : currentSecondBagTraveler.price, numberOfBounds) : currentSecondBagTraveler === null || currentSecondBagTraveler === void 0 ? void 0 : currentSecondBagTraveler.price);
};
export const setSecondBagValueForTraveler = (dispatch, productName, _ref) => {
  let {
    orderSecondBag
  } = _ref;
  return (form, secondBagTraveler, checkboxvalue) => {
    var _orderSecondBag$sellS, _orderSecondBag$sellS2;
    const {
      id: secondBagId,
      markup: secondBagMarkup,
      price: secondBagPrice
    } = secondBagTraveler || {};
    const {
      options = []
    } = (_orderSecondBag$sellS = orderSecondBag === null || orderSecondBag === void 0 || (_orderSecondBag$sellS2 = orderSecondBag.sellSpecification) === null || _orderSecondBag$sellS2 === void 0 || (_orderSecondBag$sellS2 = _orderSecondBag$sellS2.sellPriceBaggage) === null || _orderSecondBag$sellS2 === void 0 ? void 0 : _orderSecondBag$sellS2[0]) !== null && _orderSecondBag$sellS !== void 0 ? _orderSecondBag$sellS : {};
    const {
      weight: weightOfSecondBag,
      numberOfUnits: piecesOfSecondBag,
      weightUnit: weightUnitOfSecondBag
    } = options[0] || {};
    dispatch(changeFormValue(form, `${productName}.${productName}-traveler-${secondBagId}`, {
      value: checkboxvalue ? String(checkboxvalue) : '',
      included: true,
      id: secondBagId,
      markup: checkboxvalue ? secondBagMarkup : null,
      priceRaw: checkboxvalue ? secondBagPrice : 0,
      piecesOfSecondBag,
      weightOfSecondBag,
      weightUnitOfSecondBag
    }));
  };
};
//# sourceMappingURL=secondBagUtils.js.map